import React from 'react';
import {
    LineChart, Line,
    BarChart, Bar,
    PieChart, Pie, Cell,
    XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import { Card, CardBody } from "reactstrap";

// Define a color palette for charts
const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d', '#ffc658', '#ff7300'];

const DynamicChart = ({ report }) => {
    const { type, labels = [], series = [], singleValue } = report;

    // Prepare the data format for Recharts
    const chartData = labels.map((label, index) => {
        const dataPoint = { label };
        series.forEach((s) => {
            dataPoint[s.name] = s.values[index];
        });
        return dataPoint;
    });

    // Prepare the data format specifically for a PieChart
    const pieChartData = series.map((s) => ({
        name: s.name,
        value: s.values[0],
        color: s.color
    }));

    // Render the appropriate chart based on the type
    const renderChart = () => {
        switch (type) {
            //case 'SingleValue':
            //    return (
            //        <div className="text-3xl font-bold text-blue-600">
            //            {chartData}
            //        </div>
            //    );

            case 'LineChart':
                return (
                    <div style={{ width: '100%', height: '400px' }}>
                        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>{report.title}</h2>
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" stroke="#ddd" />
                                <XAxis dataKey="label" stroke="#333" />
                                <YAxis stroke="#333" />
                                <Tooltip contentStyle={{ backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '5px' }} />
                                <Legend />
                                {series && series.length > 0 && series.map((s, index) => (
                                    <Line
                                        key={index}
                                        type="monotone"
                                        dataKey={s.name}
                                        stroke={COLORS[index % COLORS.length]}
                                        strokeWidth={2}
                                        dot={{ fill: COLORS[index % COLORS.length], r: 5 }}
                                        activeDot={{ r: 8 }}
                                    />
                                ))}
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                );

            case 'BarChart':
                return (
                    <div style={{ width: '100%', height: '400px' }}>
                        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>{report.title}</h2>
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" stroke="#ddd" />
                                <XAxis dataKey="label" stroke="#333" />
                                <YAxis stroke="#333" />
                                <Tooltip contentStyle={{ backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '5px' }} />
                                <Legend />
                                {series.map((s, index) => (
                                    <Bar
                                        key={index}
                                        dataKey={s.name}
                                        fill={COLORS[index % COLORS.length]}
                                        radius={[5, 5, 0, 0]}
                                    />
                                ))}
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                );

            case 'PieChart':
                return (
                    <div style={{ width: '100%', height: '400px' }}>
                        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>{report.title}</h2>
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                                <Tooltip contentStyle={{ backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '5px' }} />
                                <Legend />
                                <Pie
                                    data={pieChartData}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={100}
                                    fill="#8884d8"
                                    label
                                    animationBegin={0}
                                    animationDuration={1000}
                                >
                                    {pieChartData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                );

            default:
                return <div className="text-red-500">Unsupported chart type: {type}</div>;
        }
    };

    return (
        <Card className={`bg-gray-100 shadow-lg rounded-xl p-4 ${type === 'SingleValue' ? 'w-full sm:w-1/2 md:w-1/3 lg:w-1/4 min-w-[200px]' : 'w-full'}`}>
            <CardBody className="text-center">
                <ResponsiveContainer width="100%" height={type === 'SingleValue' ? 100 : 400}>
                    {renderChart()}
                </ResponsiveContainer>
            </CardBody>
        </Card>
    );
};

export default DynamicChart;